// Everything in this folder and below should export a component
import React from "react";
import { ConnectedRouter } from "react-router-redux"
import { Provider } from "react-redux";

import {history} from "state/history";
import {store} from "state/createStore";

import RootPage from "components/RootPage";

import "components/reset.css";
import "components/App.css";

export default class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <RootPage />
        </ConnectedRouter>
      </Provider>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js